module.exports = __webpack_public_path__ + "img/日常维护select.d8692c62.svg";